'use client';
import { forwardRef } from 'react';
import { isNotProduction } from '../../../core/utilities/env.utils.js';

function renderWithRef(t, i, o) {
    let p = forwardRef(o);
    return p.displayName = `WithRef(${t})`, i && isNotProduction() && (p.propTypes = i), p;
}

export { renderWithRef };
